import { getAudioVolume } from '../../utils/CookiesUtils'

/* saida_ganhou.wav — the passage the machine plays as a won bonus hands back, and
   the LAST thing that happens while the bonus is still on screen. Both bonuses end
   through it, so the clip and its length live here rather than being written out
   twice: the hold each one puts on its close-out has to be the clip's length, and
   two copies of that number would drift apart.

   8000ms is measured off the file, not guessed: 22050Hz mono, 176272 frames =
   7.994s, and its 50ms RMS envelope is continuous from 0.10s to 7.85s. There is no
   tail of silence to shorten it into and no quiet seam to end it early on — the
   whole 8s is the piece, so anything less cuts the music off mid-phrase. */
export const EXIT_FANFARE_MS = 8000

const SRC = 'assets/ice-bonus/saida_ganhou.wav'

// One element for the whole app, warmed on mount. A `new Audio()` at the moment the
// round ends would fetch and decode 344KB of uncompressed wav right then, and the
// clip is supposed to start on the same beat the last prize lands.
let el = null

export const warmExitFanfare = () => {
    if (!el) {
        el = new Audio(SRC)
        el.preload = 'auto'
    }
    el.load()
    return el
}

export const playExitFanfare = () => {
    const a = warmExitFanfare()
    a.volume = getAudioVolume()
    // rewind, or the second bonus of a session would find it parked at the end
    try { a.currentTime = 0 } catch (e) { /* not loaded yet — it starts at 0 anyway */ }
    a.play().catch(() => { })
    return a
}
